import { createApp } from 'vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router/index';
import App from './App.vue'
import SweetToast from "./toaster/toast";
import { Vue3ProgressPlugin } from '@marcoschulte/vue3-progress';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import { func } from './func.js'

const app = createApp(App);

const options = {
  position: "fixed",
  height: "3px",
  color: "#e76624",
};

//const vuetify = createVuetify(App)
app.use(vuetify)
app.use(store)
app.use(router)
app.component('EasyDataTable', Vue3EasyDataTable);
app.use(Vue3ProgressPlugin, options)

app.config.globalProperties.$SweetToast = SweetToast;
app.config.globalProperties.$func = func;

app.mount('#app')


